import Component from '@glimmer/component';
import { PrismPagination } from '@mylighthouse/prism-ember';

interface GeneralTablesPaginationFooterSignature {
  Args: {
    currentPage: number;
    lastPage: number;
    onChangePageSize: (pageSizeOption: {
      label: string;
      value: number;
    }) => void;
    onSetPage: (page: number) => void;
    pageSizeDropdown: unknown;
    pageSizeOptions?: number[];
    pageSizeValue: { label: string; value: number };
    showingText: string;
    testIdPrefix?: string;
  };
}

export default class GeneralTablesPaginationFooter extends Component<GeneralTablesPaginationFooterSignature> {
  get testIdPrefix(): string {
    return this.args.testIdPrefix ?? 'table';
  }

  <template>
    <div
      class="border-neutral-default bg-elevation-surface rounded-b-200 relative flex min-h-800 items-center"
      data-test-id="{{this.testIdPrefix}}-pagination-footer"
    >
      <div class="flex items-center gap-300">
        <@pageSizeDropdown
          @onChange={{@onChangePageSize}}
          @options={{@pageSizeOptions}}
          @value={{@pageSizeValue}}
        />
        <p
          class="text-200--medium text-neutral-subdued"
          data-test-id="{{this.testIdPrefix}}-pagination-showing-text"
        >
          {{@showingText}}
        </p>
      </div>

      <div class="absolute left-1/2 -translate-x-1/2">
        <PrismPagination
          @lastPage={{@lastPage}}
          @page={{@currentPage}}
          @setPage={{@onSetPage}}
          data-test-id="{{this.testIdPrefix}}-pagination"
        />
      </div>
    </div>
  </template>
}
